import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, darkGrayFontColor, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: 'auto',
		backgroundColor: white,
		paddingBottom: 30,
	},
	tabListWrapper: {
		position: 'sticky' as const,
		top: 0,
		zIndex: 4,
		flexShrink: 0,
		backgroundColor: white,
		marginBottom: 20,
	},
	placeholderContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		color: '#999',
		fontSize: 18,
	},
	content: {
		minWidth: 1118,
	},
	unauthorized: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		gap: 8,
	},
	loading: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
	},
	contentCalendarButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: charmGray,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: '16px 16px 8px 16px',
		':hover': {
			backgroundColor: '#f7fafc',
		},
	},
	classicViewAction: {
		alignItems: 'center',
		color: darkGrayFontColor,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: 14,
		textDecoration: 'none',
		transition: 'color 300ms ease',
		':hover': {
			color: brandPrimary,
		},
	},
});
